/**
 * Shared "contact support" affordance + standardized empty-state copy
 * (Plan 04, Issues D/E).
 */

import { Button } from '@ordo/ui/button'
import { Mail } from 'lucide-react'
import { createElement } from 'react'

export const SUPPORT_EMAIL = 'support@ordoschools.com'

/**
 * Build a `mailto:` href for the support inbox, with an optional subject and
 * body. Encoded with `encodeURIComponent` (not URLSearchParams) — mail
 * clients don't decode `+` back into spaces.
 */
export function supportMailto(subject?: string, body?: string): string {
  const query = [
    subject ? `subject=${encodeURIComponent(subject)}` : '',
    body ? `body=${encodeURIComponent(body)}` : '',
  ]
    .filter(Boolean)
    .join('&')
  return query ? `mailto:${SUPPORT_EMAIL}?${query}` : `mailto:${SUPPORT_EMAIL}`
}

/**
 * The standardized "Email Us" action button. Drop into an
 * `EmptyState`'s `action` slot.
 */
export function SupportEmailButton({ subject, label = 'Email Us' }: { subject?: string; label?: string }) {
  return createElement(
    Button,
    { asChild: true },
    createElement('a', { href: supportMailto(subject) }, createElement(Mail, { className: 'h-4 w-4' }), label),
  )
}

/**
 * Standardized copy for the "user has an org/membership but no linked
 * school/location" empty state (Issue E). Use on Orders / Production
 * Records / Settings and the no-memberships landing.
 */
export const NO_SCHOOLS_EMPTY = {
  title: 'No schools linked to your account yet',
  description: 'Reach out to our Ordo support team to get this resolved.',
} as const
